import styled from "@emotion/styled";

export const SectionTitle = styled.div`
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: #171a1fff;
  margin-bottom: 16px;
`;
